import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGuinea = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_850)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M16.174 0.746437C14.874 0.264047 13.4679 0 12 0C10.5322 0 9.12615 0.264047 7.82621 0.746344L7.30444 12L7.82616 23.2537C9.12615 23.736 10.5322 24 12 24C13.4679 24 14.874 23.736 16.174 23.2536L16.6958 12L16.174 0.746437Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0 12C0 17.1595 3.2565 21.5581 7.82611 23.2536V0.746346C3.2565 2.44191 0 6.84038 0 12Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M24 12C24 6.84038 20.7435 2.44191 16.1739 0.746346V23.2536C20.7435 21.5581 24 17.1595 24 12Z",
				fill: "#6DA544"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_850",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgGuinea;
